import { css } from 'lit';

export default css`
    :host {
        --transition-slide: 0.2s ease-out;
        --fab-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
    }

    .view {
        display: flex;
        flex-direction: column;
        height: 100%;
        background-color: var(--color-surface-secondary);
    }

    .main {
        display: flex;
        flex: 1;
        overflow: hidden;
        gap: var(--metrics-spacing-s);
        padding: var(--metrics-spacing-s);
    }

    .sidebar {
        display: flex;
        flex-direction: column;
        min-width: 356px;
        flex: 1;
        overflow: hidden;
        gap: var(--metrics-spacing-s);
    }

    .selection-bar {
        position: sticky;
        top: 0;
        z-index: 5;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: var(--metrics-spacing-xs) var(--metrics-spacing-s);
        background-color: var(--color-surface-primary);
        border-bottom: 1px solid var(--color-border-divider-light);
        font-size: var(--font-size-body-s);
        color: var(--color-text-secondary);
    }

    .selection-bar button {
        min-width: auto;
    }

    .sidebar-item-fill {
        position: relative;
        display: flex;
        flex-direction: column;
        flex: 1;
        min-height: 0;
    }

    .sidebar-item-fill ki-ds-pwa-timeseries-list {
        flex: 1;
        min-height: 0;
    }

    .content {
        display: flex;
        flex-direction: column;
        flex: 3;
        overflow: hidden;
    }

    .mobile-graph-header {
        display: none;
    }

    .content-body {
        flex: 1;
        min-height: 0;
        overflow: hidden;
    }

    .content-body ki-ds-pwa-graph-container {
        display: block;
        height: 100%;
    }

    .fab-container {
        display: none;
    }

    @media (max-width: 768px) {
        .main {
            flex-direction: column;
            padding: var(--metrics-spacing-s);
        }

        .sidebar {
            min-width: unset;
            width: 100%;
            flex: 1;
        }

        .content {
            position: fixed;
            inset: 0;
            z-index: 100;
            background-color: var(--color-surface-secondary);
            transform: translateY(100%);
            transition: transform var(--transition-slide);
            pointer-events: none;
            flex: unset;
        }

        .content.content-open {
            transform: translateY(0);
            pointer-events: auto;
        }

        .mobile-graph-header {
            display: flex;
            align-items: center;
            padding: var(--metrics-spacing-m);
            background-color: var(--color-surface-primary);
            border-bottom: 1px solid var(--color-border-divider-light);
            position: relative;
            z-index: 10;
            gap: var(--metrics-spacing-s);
        }

        .mobile-graph-header .close-btn {
            order: 1;
            margin-left: auto;
        }

        .mobile-graph-title {
            flex: 1;
            font-size: var(--font-size-body-m);
            font-weight: var(--font-weight-head-s);
            color: var(--color-text-primary);
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .content-body {
            flex: 1;
            min-height: 0;
            overflow: hidden;
            padding: var(--metrics-spacing-m);
        }

        .fab-container {
            display: flex;
            position: fixed;
            bottom: var(--metrics-spacing-xl);
            right: var(--metrics-spacing-xl);
            gap: var(--metrics-spacing-s);
            z-index: 10;
            animation: fab-slide-up var(--transition-slide);
        }

        .fab-container[hidden] {
            display: none;
        }

        .fab-container button {
            display: flex;
            align-items: center;
            gap: var(--metrics-spacing-s);
            padding: var(--metrics-spacing-l) var(--metrics-spacing-l);
            min-width: auto;
            box-shadow: var(--fab-shadow);
            border-radius: var(--metrics-radius-m);
        }

        .fab-container button:active {
            transform: scale(0.95);
        }

        @keyframes fab-slide-up {
            from {
                transform: translateY(100%);
                opacity: 0;
            }
            to {
                transform: translateY(0);
                opacity: 1;
            }
        }
    }
`;
